<template>
	<div
		:style="{ ...task.style, ...taskBarStyle, zIndex: hover ? 1 : 0 }"
		:class="['gantt-bar', isEditable('drag') ? 'gantt-bar--true' : 'gantt-bar--false']"
		@mouseenter="setHoverPosition"
	>
		<div
			style="height: 100%; width: 100%"
			:class="isEditable('drag') ? 'grab' : ''"
			@mousedown="isEditable('drag') ? $emit('mouse-down-move') : ''"
			@click="barClickable ? $emit('click-bar') : false"
		>
			<p class="gantt-bar__name" :style="taskBarNameStyle">
				<slot name="task-name" :task="task" />
			</p>
			<v-hover v-if="isEditable('left') && (task.leftDot || dragging)" v-model="leftHover">
				<div
					class="gantt-bar__left"
					@mousedown.stop="isEditable('left') ? $emit('mouse-down-resize', 'left') : ''"
				>
					<span
						v-show="((isResize && leftResizing) || dragging) && task.id == taskBar.id"
						class="display-time-left"
					>
						{{ formatDisplayTimeLeft }}
					</span>
				</div>
			</v-hover>
			<v-hover å v-if="isEditable('right') && (task.rightDot || dragging)" v-model="rightHover">
				<div
					class="gantt-bar__right"
					@mousedown.stop="isEditable('right') ? $emit('mouse-down-resize', 'right') : ''"
				>
					<span
						v-show="((isResize && rightResizing) || dragging) && task.id == taskBar.id"
						class="display-time-right"
					>
						{{ formatDisplayTimeRight }}
					</span>
				</div>
			</v-hover>
		</div>
		<slot
			name="hover-card"
			:hover="hover && !leftHover && !rightHover && !dragging && !leftResizing && !rightResizing"
			:task="task"
			:hoverPosition="hoverPosition"
			:taskLine="taskLine"
		/>
	</div>
</template>

<script>
export default {
	props: {
		task: {
			type: Object,
			required: true,
		},
		taskBar: {
			type: Object,
			required: false,
			default: () => ({}),
		},
		taskBarStyle: {
			type: Object,
			required: false,
			default: () => ({}),
		},
		hover: {
			type: Boolean,
			required: false,
			default: false,
		},
		// true or false or { left: true, right: true, drag: true}
		editableStatus: {
			type: null,
			required: false,
			default: false,
		},
		taskBarNameStyle: {
			type: Object,
			required: false,
			default: () => ({}),
		},
		rightResizing: {
			type: Boolean,
			required: false,
			default: false,
		},
		leftResizing: {
			type: Boolean,
			required: false,
			default: false,
		},
		dragging: {
			type: Boolean,
			required: false,
			default: false,
		},
		taskLine: {
			type: null,
			required: false,
			default: null,
		},
		formatDisplayTimeLeft: {
			type: String,
			required: false,
		},
		formatDisplayTimeRight: {
			type: String,
			required: false,
		},
		isResize: {
			type: Boolean,
			required: false,
			default: false,
		},
		barClickable: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	data() {
		return {
			rightHover: false,
			leftHover: false,
			hoverPosition: {},
		}
	},
	methods: {
		setHoverPosition(e) {
			this.hoverPosition = e
		},
		isEditable(action) {
			if (this.editableStatus === true) {
				return true
			} else if (this.editableStatus === false) {
				return false
			} else {
				return this.editableStatus[action]
			}
		},
	},
}
</script>

<style scoped lang="scss">
@import "../../../stylesheet/shared/color.scss";

.task-name {
	padding: 4px;
	display: flex;
	border-right: solid 1px #80808045;
	align-items: center;
	padding-left: 16px;
	// width: 12rem;
	font-size: 15px;
	justify-content: center;
}
.gantt-calendar {
	overflow-x: scroll;
	overflow-y: hidden;
	border-left: solid 1px #80808045;
}

.gantt-year-month {
	position: relative;
	height: 2rem;
}
.gantt-date {
	// height: 5rem;
	position: relative;
}

.calendar-date {
	position: absolute;
	background: $main-color;
	color: white;
	font-weight: bold;
	border-bottom: solid 1px #80808045;
	border-right: solid 1px #80808045;
	border-top: solid 1px #80808045;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 2rem;
	button {
		z-index: 1;
	}
}
.gantt-day {
	position: relative;
	height: 3rem;
}
.gantt-days {
	position: absolute;
	border-bottom: solid 1px #80808045;
	border-right: solid 1px #80808045;
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: bold;
	height: 3rem;
	font-size: 0.8rem;
	flex-direction: column;
	cursor: pointer;
}
.saturday {
	background: #dbeafe;
}
.sunday {
	background: #fee2e2;
}
.today {
	background: #dc2626;
	color: white;
}
.gantt-height {
	position: absolute;
}
.days-height {
	position: absolute;
	border-bottom: solid 1px #80808045;
	border-right: solid 1px #80808045;
}
.gantt-bar-area {
	position: relative;
}

.gantt-bar {
	position: absolute;
	background: orange;
	height: 20px;
	border-radius: 10px;
	box-shadow: 0 0 5px rgb(0 0 0 / 25%);
	&--true {
		cursor: grab;
	}
	&__name {
		overflow: visible;
		width: 100%;
	}
	&__left {
		top: 6px;
		left: -6px;
		cursor: col-resize;
		position: absolute;
		background: #808080a1;
		height: 8px;
		width: 8px;
		border: 1px solid grey;
	}

	&__right {
		top: 6px;
		right: -6px;
		cursor: col-resize;
		position: absolute;
		background: #808080a1;
		height: 8px;
		width: 8px;
		border: 1px solid grey;
	}
	.display-time-left {
		background: whitesmoke;
		position: absolute;
		padding: 4px;
		font-size: 0.9rem;
		border-radius: 5px;
		bottom: 27px;
		text-align: center;
		opacity: 0.8;
	}

	.display-time-right {
		background: whitesmoke;
		position: absolute;
		padding: 4px;
		font-size: 0.9rem;
		border-radius: 5px;
		bottom: 27px;
		text-align: center;
		opacity: 0.8;
		right: 6px;
	}
}

.grab {
	cursor: grab;
}
</style>
